var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdPanel",
    [
      _c(
        "EmdPanelSection",
        {
          attrs: {
            title: _vm.$t(
              "recipients.create.automatic_anticipation_settings.title"
            ),
          },
        },
        [
          _c(
            "EmdFormGroup",
            {
              attrs: {
                label: _vm.$t(
                  "recipients.create.automatic_anticipation_settings.antecipation"
                ),
              },
            },
            [
              _c("EmdSwitcher", {
                attrs: {
                  label: _vm.automatic_anticipation_settings.enabled
                    ? _vm.$t("recipients.create.active")
                    : _vm.$t("recipients.create.inactive"),
                  id: "automatic_anticipation_settings",
                },
                model: {
                  value: _vm.automatic_anticipation_settings.enabled,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.automatic_anticipation_settings,
                      "enabled",
                      $$v
                    )
                  },
                  expression: "automatic_anticipation_settings.enabled",
                },
              }),
            ],
            1
          ),
          _c("EmdFormGroup", [
            _c(
              "label",
              {
                staticClass: "emd-label",
                class: {
                  _required: _vm.automatic_anticipation_settings.enabled,
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "recipients.create.automatic_anticipation_settings.type"
                      )
                    ) +
                    " "
                ),
                _c(
                  "emd-tippy",
                  {
                    staticClass: "eu-ml_1",
                    attrs: {
                      "data-template": "prepayment_type_info",
                      id: "prepayment_type_info",
                      type: "html",
                      position: "bottom",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "uil uil-info-circle",
                      class: "emd-text _color_subtle",
                    }),
                    _c(
                      "emd-tippy-template-HTML",
                      { attrs: { id: "prepayment_type_info" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-transform": "initial",
                              "letter-spacing": "0",
                            },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "recipients.create.prepayment_info",
                                      { url: _vm.prepaymentLink }
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "eu-mt_2" },
              [
                _c("EmdRadio", {
                  staticClass: "eu-mr_4 eu-mb_2",
                  attrs: {
                    label: _vm.$t(
                      "recipients.create.automatic_anticipation_settings.type_volume"
                    ),
                    id: "antecipation_type_volume",
                    name: "automatic_anticipation_settings",
                    value: "full",
                  },
                  model: {
                    value: _vm.automatic_anticipation_settings.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.automatic_anticipation_settings, "type", $$v)
                    },
                    expression: "automatic_anticipation_settings.type",
                  },
                }),
                _c("EmdRadio", {
                  staticClass: "eu-mr_4 eu-mb_2",
                  attrs: {
                    label: _vm.$t(
                      "recipients.create.automatic_anticipation_settings.type_d+x"
                    ),
                    id: "antecipation_type_d+x",
                    name: "automatic_anticipation_settings",
                    value: "1025",
                  },
                  model: {
                    value: _vm.automatic_anticipation_settings.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.automatic_anticipation_settings, "type", $$v)
                    },
                    expression: "automatic_anticipation_settings.type",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.automatic_anticipation_settings.type &&
          _vm.automatic_anticipation_settings.type === "full"
            ? _c(
                "EmdFormGroup",
                {
                  attrs: {
                    label: _vm.$t(
                      "recipients.create.automatic_anticipation_settings.volume_percentage"
                    ),
                    required: _vm.automatic_anticipation_settings.enabled,
                    feedbacks: _vm.feedbacks(
                      _vm.vuelidate.automatic_anticipation_settings
                        .volume_percentage,
                      _vm.automatic_anticipation_settings.enabled
                    ),
                    state: _vm.getState(
                      _vm.vuelidate.automatic_anticipation_settings
                        .volume_percentage,
                      _vm.automatic_anticipation_settings.enabled
                    ),
                  },
                },
                [
                  _c("EmdInput", {
                    attrs: { name: "volume_percentage", type: "number" },
                    on: {
                      input:
                        _vm.vuelidate.automatic_anticipation_settings
                          .volume_percentage.$touch,
                    },
                    model: {
                      value:
                        _vm.automatic_anticipation_settings.volume_percentage,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.automatic_anticipation_settings,
                          "volume_percentage",
                          $$v
                        )
                      },
                      expression:
                        "automatic_anticipation_settings.volume_percentage",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.automatic_anticipation_settings.type &&
          _vm.automatic_anticipation_settings.type === "1025"
            ? _c(
                "EmdFormGroup",
                {
                  attrs: {
                    label: _vm.$t(
                      "recipients.create.automatic_anticipation_settings.delay"
                    ),
                    required: _vm.automatic_anticipation_settings.enabled,
                  },
                },
                [
                  _c("EmdInput", {
                    attrs: { name: "delay", type: "number" },
                    model: {
                      value: _vm.automatic_anticipation_settings.delay,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.automatic_anticipation_settings,
                          "delay",
                          $$v
                        )
                      },
                      expression: "automatic_anticipation_settings.delay",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }